// 引入axios 实例
import request from "@/utils/request";
export const setSchoolCarouselSet = (data) => {
  return request({
    url: "/api/school/setSchoolCarouselSet",
    method: "post",
    params: data,
  });
};
